import { offerSchema } from '@cc-shopping/contracts/compare/schema/base';
import { transformedImageSizeMapSchema } from '@cc-shopping/contracts/cross-site/image/schema';
import * as v from 'valibot';

export const marketplaceSearchResponseSchema = v.object({
  marketplaceSearch: v.object(
    {
      entities: v.array(offerSchema, 'entities must be an array of offers'),
      total: v.number('total is required in marketplaceSearch'),
    },
    'marketplaceSearch must be a valid object',
  ),
});

const entitySchema = v.object(
  {
    ...offerSchema.entries,
    image: v.undefined(),
    imageOptions: transformedImageSizeMapSchema,
  },
  'entity must be a valid object',
);

export const entitiesResponseSchema = v.array(entitySchema, 'entities must be an array of objects');

export const getEntitiesByIdIdsSchema = v.optional(
  v.array(
    v.pipe(v.string('id must be a string'), v.uuid('id must be a valid UUID')),
    'ids must be an array of valid UUIDs',
  ),
);
export const getEntitiesByIdLegacyIdsSchema = v.optional(
  v.array(v.number('legacyId must be a number'), 'legacyIds must be an array of numbers'),
);
